// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box, Button, Container as MuiContainer, styled, Typography } from '@mui/material';

const Wrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '700px',
  background: 'url(pic_bac.webp) no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center'
});

const Container = styled(MuiContainer)({
  margin: '0 auto'
});

const Tip = styled(MuiContainer)({
  position: 'absolute',
  top: 625,
  minHeight: 150,
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 77px',
  background: 'linear-gradient(90deg, #147251 0%, #05382A 100%)',
  borderRadius: 6
});

function Hero() {
  return (
    <Wrapper>
      <Container>
        <Typography color="#fff" fontSize="3rem" variant="h1">
          zCloak Network:
          <br />
          World’s First zk-Guessing for
          <br />
          <Typography color="primary" variant="inherit">
            the World Cup Games.
          </Typography>
        </Typography>
        <Button
          endIcon={<ArrowRightAltIcon />}
          onClick={() =>
            window.open(
              'https://zcloaknetwork.medium.com/phase-ii-worlds-first-zk-guessing-for-the-world-cup-games-zero-knowledge-proof-for-semi-finals-680d66404639'
            )
          }
          size="large"
          sx={{ marginTop: 5 }}
          variant="contained"
        >
          More Details
        </Button>
      </Container>
      <Tip>
        <Typography color="white" fontWeight={400} textAlign="center" variant="h5">
          <b>zCloak Network</b> is holding the world’s first zero-knowledge-based World Cup Guessing
          Event with its partners. In this event, you can prove whether your guess is correct (e.g.
          your team enters semi-finals), without telling anyone what your guess is. Here you will
          get a taste of zCloak Network’s efforts to protect privacy again.
        </Typography>
      </Tip>
    </Wrapper>
  );
}

export default Hero;
